import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import NewPred from './NewPred';
import './css/Lab.css';

const PredictionNew = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <NewPred />
            </div>
        </div>
    );
};

export default PredictionNew;